module.exports = __webpack_public_path__ + "static/media/Valorant_Logo.d62bdfb7.png";